import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import apiClient from '../../utils/api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tokenValid, setTokenValid] = useState(true);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setTokenValid(false);
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('Passwort muss mindestens 6 Zeichen lang sein');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      return;
    }

    setLoading(true);

    try {
      await apiClient.resetPassword(token, password);
      // Success - navigate to login
      navigate('/login', {
        state: { message: 'Passwort erfolgreich zurückgesetzt. Bitte melden Sie sich an.' }
      });
    } catch (err) {
      setError(err.message || 'Fehler beim Zurücksetzen des Passworts. Der Link ist möglicherweise abgelaufen.');
    } finally {
      setLoading(false);
    }
  };

  if (!tokenValid) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <img
            src="https://customer-assets.emergentagent.com/job_f48ed865-f137-40ec-8ec5-750617ca0014/artifacts/jm5y5oub_logo.png"
            alt="ZENTA Logo"
            className="auth-logo"
          />
          <h1 className="auth-title">ZENTA</h1>
          <div className="error-message" data-testid="invalid-token-message">
            <p><strong>Ungültiger Link</strong></p>
            <p>Der Reset-Link ist ungültig oder fehlt.</p>
          </div>
          <div className="auth-link">
            <Link to="/forgot-password" data-testid="request-new-link">
              Neuen Link anfordern
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <img
          src="https://customer-assets.emergentagent.com/job_f48ed865-f137-40ec-8ec5-750617ca0014/artifacts/jm5y5oub_logo.png"
          alt="ZENTA Logo"
          className="auth-logo"
        />
        <h1 className="auth-title">ZENTA</h1>
        <p className="auth-subtitle">Neues Passwort setzen</p>

        {error && (
          <div className="error-message" data-testid="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">Neues Passwort</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              data-testid="password-input"
              placeholder="Mindestens 6 Zeichen"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm-password">Passwort bestätigen</label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              data-testid="confirm-password-input"
              placeholder="Passwort wiederholen"
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="submit-button"
          >
            {loading ? 'Speichere...' : 'Passwort zurücksetzen'}
          </button>
        </form>

        <div className="auth-link">
          <Link to="/login" data-testid="back-to-login-link">
            Zurück zum Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
